import { useCallback, useEffect } from 'react';

// Minimal replacement for the theme's magnific-popup: one image at a time,
// arrow-key and click navigation, Escape to close.
const Lightbox = ({ images, index, onClose, onStep }) => {
  const step = useCallback((delta) => onStep(delta), [onStep]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, step]);

  const image = images[index];
  if (!image) return null;

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Photo viewer"
      onClick={onClose}
    >
      <img src={image} alt="" onClick={(e) => e.stopPropagation()} />

      <button
        type="button"
        className="lightbox__close"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
      <button
        type="button"
        className="lightbox__nav lightbox__nav--prev"
        aria-label="Previous photo"
        onClick={(e) => {
          e.stopPropagation();
          step(-1);
        }}
      >
        &#8249;
      </button>
      <button
        type="button"
        className="lightbox__nav lightbox__nav--next"
        aria-label="Next photo"
        onClick={(e) => {
          e.stopPropagation();
          step(1);
        }}
      >
        &#8250;
      </button>
      <p className="lightbox__count">
        {index + 1} / {images.length}
      </p>
    </div>
  );
};

export default Lightbox;
